import CardSkeleton from "./CardSkeleton";
import SkeletonElement from "./SkeletonElement";

/**
 * Props for CardGridSkeleton component
 * @param leftColumnCards - Number of cards in left column (default: 2)
 * @param rightColumnCards - Number of cards in right column (default: 2)
 * @param className - Additional CSS classes
 */
type CardGridSkeletonProps = {
  leftColumnCards?: number;
  rightColumnCards?: number;
  className?: string;
};

export default function CardGridSkeleton({
  leftColumnCards = 2,
  rightColumnCards = 2,
  className = ""
}: CardGridSkeletonProps) {
  return (
    <div className={className} data-testid="card-grid-skeleton">
      <div className="mt-12">
        <SkeletonElement height="h-6" width="w-1/3" className="mb-2" />
        <SkeletonElement height="h-4" width="w-1/2" />
      </div>

      <div className="mt-8 flex flex-col md:flex-row gap-x-10 gap-y-10">
        <div className="basis-1/3">
          <div className="flex flex-col gap-y-10">
            {Array.from({ length: leftColumnCards }).map((_, index) => (
              <CardSkeleton key={`left-${index}`} width={100} />
            ))}
          </div>
        </div>
        <div className="basis-2/3">
          <div className="flex flex-col gap-y-10">
            {Array.from({ length: rightColumnCards }).map((_, index) => (
              <CardSkeleton key={`right-${index}`} width={100} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
